import React, { useState, useEffect } from 'react';
import { recipes } from '../services/api';
import '../styles/StarRating.css';

const StarRating = ({
  recipeId,
  initialRating = 0,
  averageRating = 0,
  ratingCount = 0,
  readonly = false,
  onRate
}) => {
  const [rating, setRating] = useState(initialRating);
  const [hover, setHover] = useState(0);
  const [loading, setLoading] = useState(false);

  // Update local rating state when initialRating prop changes
  useEffect(() => {
    setRating(initialRating);
  }, [initialRating]);

  const handleRate = async (clickedRating) => {
    if (readonly || loading) return;

    const token = localStorage.getItem('token');
    if (!token) {
      alert('Jelentkezz be az értékeléshez!');
      return;
    }

    setLoading(true);
    try {
      // Check if user clicked the same star (deletion)
      const isDeletion = clickedRating === rating;

      let response;
      if (isDeletion) {
        // Send null to indicate deletion
        response = await recipes.rateRecipe(recipeId, null);
        setRating(0); // Reset local rating
      } else {
        // Normal rating
        response = await recipes.rateRecipe(recipeId, clickedRating);
        setRating(clickedRating);
      }

      if (onRate) onRate(response.data);
    } catch (error) {
      console.error('Rating error:', error);
      alert('Hiba történt az értékelés mentésekor');
    } finally {
      setLoading(false);
    }
  };

  // Show rating based on mode: readonly shows average, interactive shows user's rating or hover
  const displayRating = readonly ? averageRating : (hover || rating);

  // Don't show any filled stars if there's no rating at all
  const shouldShowStars = readonly ? averageRating > 0 : (hover > 0 || rating > 0);

  return (
    <div className="star-rating-container">
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            className={`star ${shouldShowStars && star <= displayRating ? 'filled' : ''} ${readonly ? 'readonly' : ''} ${!readonly && star === rating ? 'user-rated' : ''}`}
            onClick={() => !readonly && handleRate(star)}
            onMouseEnter={() => !readonly && setHover(star)}
            onMouseLeave={() => !readonly && setHover(0)}
            disabled={loading || readonly}
            title={!readonly && star === rating ? 'Kattints újra az értékelés törléséhez' : ''}
          >
            ★
          </button>
        ))}
      </div>
      <div className="rating-info">
        <span className="average-rating">
          {averageRating > 0 ? averageRating.toFixed(1) : 'Nincs értékelés'}
        </span>
        {ratingCount > 0 && (
          <span className="rating-count">({ratingCount} értékelés)</span>
        )}
      </div>
      {!readonly && rating > 0 && (
        <div className="user-rating-info">
          Te: {rating} csillag <span className="delete-hint">(Kattints újra a törléshez)</span>
        </div>
      )}
    </div>
  );
};

export default StarRating;
